export default __webpack_public_path__ + "static/media/ic_glp_24.ac0815eb.svg";